var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleCardColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.025 23.491v8.786a1.098 1.098 0 0 0 1.098 1.098h8.786a1.098 1.098 0 0 0 1.098-1.098V3.723a1.098 1.098 0 0 0-1.098-1.098H4.123a1.098 1.098 0 0 0-1.098 1.098v19.768z",
    stroke: "#818B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.775 23.49v8.786a1.099 1.099 0 0 1-1.098 1.098H4.123a1.098 1.098 0 0 1-1.098-1.098V23.49",
    stroke: "#818B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.007 32.134 13.179-8.61 4.096-2.69a1.098 1.098 0 0 0 .33-1.527l-4.536-6.798M17.302 3.778l7.215 3.899a1.098 1.098 0 0 1 .472 1.537L23.276 12.4l-1.098 2.197-4.876 8.654-3.295 6.303M3.025 22.392h10.982M3.025 15.804h10.982M3.025 9.214h10.982",
    stroke: "#818B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleCardColor);
export default __webpack_public_path__ + "static/media/vehicle-card-color.5f09f7e74a5695b91b3d3fe4263531db.svg";
export { ForwardRef as ReactComponent };